module.exports = "/_next/static/media/9fd99123493499121463187774cbd040.svg";